
import { CaixaLotteryType } from "./types";
import { CAIXA_LOTTERIES } from "./lotteryData";

export const generateCaixaNumbers = (lotteryType: CaixaLotteryType, quantity: number = 1): string[][] => {
  const lottery = CAIXA_LOTTERIES[lotteryType];
  const results: string[][] = [];
  
  for (let i = 0; i < quantity; i++) {
    const numbers: number[] = [];
    const maxNum = lotteryType === "lotomania" ? 100 : 
                   lotteryType === "lotofacil" ? 25 :
                   lotteryType === "quina" ? 80 :
                   lotteryType === "dupla-sena" ? 50 :
                   lotteryType === "dia-de-sorte" ? 31 : 60;
    
    while (numbers.length < lottery.minNumbers) {
      const num = Math.floor(Math.random() * maxNum) + 1;
      if (!numbers.includes(num)) {
        numbers.push(num);
      }
    }
    
    numbers.sort((a, b) => a - b);
    results.push(numbers.map(n => n.toString().padStart(2, '0')));
  }
  
  return results;
};

export const generateCaixaPredictions = (
  lotteryType: CaixaLotteryType, 
  count: number, 
  aiType: "gemini" | "chatgpt" | "claude"
): Array<{ value: string; numbers: string[] }> => {
  const predictions: Array<{ value: string; numbers: string[] }> = [];
  
  for (let i = 0; i < count; i++) {
    const numbers = generateCaixaNumbers(lotteryType, 1)[0];
    predictions.push({
      value: numbers.join(' - '),
      numbers: numbers
    });
  }
  
  return predictions;
};
